import React from "react";
import { IconButton, Stack, Tooltip } from "@mui/material";
import { Check as CheckIcon, Close as CloseIcon } from "@mui/icons-material";
import { useIntl } from "react-intl";
import { VERDICT } from "./activityConstants";

// The two answers an AI suggestion is waiting for.
//
// A suggested row is a question — keep this or not — so it gets both answers as
// buttons rather than one "Approve" glyph and an ordinary bin sitting among the
// other row controls. Accept PATCHes `approved: true` and the row becomes a
// plain activity; reject DELETEs it. They live in one tinted pill so the pair
// reads as a single decision, and they take the place of the row's delete icon:
// a proposal is rejected, not deleted.
//
// Shared by the dashboard and the impact's activity panel — the same decision in
// two places, so it must not drift between them.
export default function SuggestionVerdict({ title, busy, onAccept, onReject }) {
    const intl = useIntl();
    const acceptLabel = intl.formatMessage(
        { id: "activity.accept_named", defaultMessage: "Accept {title}" },
        { title }
    );
    const rejectLabel = intl.formatMessage(
        { id: "activity.reject_named", defaultMessage: "Reject {title}" },
        { title }
    );

    return (
        <Stack
            direction="row"
            sx={{
                flexShrink: 0,
                borderRadius: 5,
                border: "1px solid rgba(0,67,142,0.25)",
                backgroundColor: "background.paper",
            }}
        >
            {/* describeChild: the tooltip repeats the button's own name, so it is
                a description here — otherwise it would replace the name and the
                two buttons would read identically to a screen reader. */}
            <Tooltip title={acceptLabel} describeChild>
                {/* A disabled button fires no events, so the tooltip needs a
                    wrapper that still does. */}
                <span>
                    <IconButton
                        size="small"
                        disabled={busy}
                        onClick={() => onAccept()}
                        aria-label={acceptLabel}
                        sx={{
                            color: VERDICT.accept.color,
                            "&:hover": { backgroundColor: VERDICT.accept.bg },
                        }}
                    >
                        <CheckIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title={rejectLabel} describeChild>
                <span>
                    <IconButton
                        size="small"
                        disabled={busy}
                        onClick={() => onReject()}
                        aria-label={rejectLabel}
                        sx={{
                            color: VERDICT.reject.color,
                            "&:hover": { backgroundColor: VERDICT.reject.bg },
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
        </Stack>
    );
}
